const searchWithList = (cards_list) => {
    let search_input = document.getElementById("search-input") as HTMLInputElement;

    if (search_input.value.length > 0) {
        let search_card_list = cards_list.filter((card) => {
            let merged_parameter = "";

            merged_parameter += card["name"].toLowerCase() + " ";

            Object.keys(card["specs"]).map((spec) => {
                if (Array.isArray(card["specs"][spec]["value"]))
                    merged_parameter += card["specs"][spec]["value"].join(" ");
                else
                    merged_parameter += card["specs"][spec]["value"] + " ";
            })

            return merged_parameter.includes(
                search_input.value.toLowerCase()
            )
        });

        search_input.focus();
        search_input.setSelectionRange(0, search_input.value.length);

        return search_card_list;
    }
};

export const LibraryUtils = {
    searchWithList,
}